// src/pages/Contact.js
import React from "react";
import contactImage from "../assets/contactUs1.jpg"; // Ensure the correct image path
import ContactForm from "../components/ContactForm.js";

const ContactUs = () => {
    return (
        <div className="w-full bg-gray-900 text-white">
            {/* Contact Us Section */}
            <div id="contact-us" className="bg-gray-900 text-white p-12 sm:p-20 text-center">
                <h2 className="text-4xl sm:text-5xl font-bold mb-6">Contact Us</h2>
                <p className="text-lg sm:text-xl leading-relaxed text-justify">
                    Get in touch with Proalgenix. Whether you’re interested in our products, exploring partnership opportunities, or have general inquiries — we’re here to help.
                </p>

                {/* Large Contact Us Image */}
                <div className="flex justify-center my-12">
                    <img
                        src={contactImage}
                        alt="Contact Us"
                        className="w-full max-w-4xl object-cover rounded-lg shadow-lg"
                    />

                </div>
                <ContactForm />
            </div>


            {/* Contact Details Section */}
            <section className="py-12 sm:py-20 px-6 bg-gray-800 text-center">
                <h2 className="text-3xl sm:text-4xl font-bold mb-8">Our Contact Details</h2>

                <div className="max-w-4xl mx-auto space-y-6">
                    <p className="text-lg">
                        📍 <span className="text-yellow-400 font-semibold">Address:</span>
                        123 XXXXXXXXX Avenue, Innovation City, India
                    </p>
                    <p className="text-lg">
                        📞 <span className="text-yellow-400 font-semibold">Phone:</span>
                        +91 98765 XXXXX
                    </p>
                    <p className="text-lg">
                        📧 <span className="text-yellow-400 font-semibold">Email:</span>
                        <a href="mailto:info@proalgenix.com" className="text-blue-400 hover:underline">
                            info@proalgenix.com
                        </a>
                    </p>
                </div>
            </section>

            {/* Google Maps Embed Section */}
            <section className="py-12 sm:py-20 px-6 bg-gray-800">
                <h2 className="text-3xl sm:text-4xl font-bold text-center mb-8">Visit Us</h2>

                <div className="flex justify-center">
                    <iframe aria-label="Proalgenix Google Maps Location"
                        title="Proalgenix Location"
                        className="w-full max-w-4xl h-80 rounded-lg shadow-lg"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.902334011896!2d90.38821881543132!3d23.75088509466786!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c7b4f95f4b1b%3A0x8dbbb2e370a44bfa!2sInnovation%20City!5e0!3m2!1sen!2sin!4v1621234567890!5m2!1sen!2sin"
                        allowFullScreen=""
                        loading="lazy"
                    ></iframe>
                </div>
            </section>
        </div>
    );
};

export default ContactUs;
